import { SimpleCommand } from './../../../../commanding/SimpleCommand';
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 27.11.13, 11:21
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
import {EnvGlobalsHandler} from "../../../EnvGlobalsHandler";
import {BasicModel} from "../../../model/BasicModel";
import {Country, CountryCodes} from "@goodgamestudios/world-assignment";
import { debug } from '../../../../logging/debug';

export class BasicCheckAgeGateActivityCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        let initialDetectedCountry: Country = (<Country>commandVars);

        // Check if AgeGate is active
        if (!EnvGlobalsHandler.globals.ageGateFeatureIsActive) {
            debug("AgeGate feature is not activated");

            // Don't activate AgeGate feature
            BasicModel.ageGateData.isAgeGateActive = false;
            return;
        }

        // Activate AgeGate only for USA
        if (initialDetectedCountry.ggsCountryCode == CountryCodes.USA) {
            let ageGateData: string = EnvGlobalsHandler.globals.accountCookie.ageGateData;

            // Age gate data exists: Age has been validated already
            if (ageGateData) {
                BasicModel.ageGateData.isAgeGateActive = false;
            }
            // Age not validate yet, activate age gate
            else {
                BasicModel.ageGateData.isAgeGateActive = true;
            }
        }

        debug("isAgeGateActive: " + BasicModel.ageGateData.isAgeGateActive);
    }
}
